// src/services/emailService.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* --------------------------------------------------
   🔍 VALIDATION FRONTEND – Alignée avec Pydantic
-------------------------------------------------- */
export const validateContactData = (data) => {
  const errors = {};

  // Nom (2–100)
  if (!data.name || data.name.trim().length < 2)
    errors.name = "Le nom doit contenir au moins 2 caractères.";
  else if (data.name.length > 100)
    errors.name = "Le nom ne peut pas dépasser 100 caractères.";

  // Email
  if (!data.email)
    errors.email = "Le courriel est obligatoire.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))
    errors.email = "Le courriel est invalide.";

  // Company (2–200)
  if (!data.company || data.company.trim().length < 2)
    errors.company = "Le nom de l'organisation doit contenir au moins 2 caractères.";
  else if (data.company.length > 200)
    errors.company = "L'organisation ne peut pas dépasser 200 caractères.";

  // Subject (5–200)
  if (!data.subject)
    errors.subject = "Choisissez un type de projet.";
  else if (data.subject.trim().length < 5)
    errors.subject = "Le sujet doit contenir au moins 5 caractères.";
  else if (data.subject.length > 200)
    errors.subject = "Le sujet ne peut pas dépasser 200 caractères.";

  // Message (10–2000)
  if (!data.message || data.message.trim().length < 10)
    errors.message = "Le message doit contenir au moins 10 caractères.";
  else if (data.message.length > 2000)
    errors.message = "Le message ne peut pas dépasser 2000 caractères.";

  return errors;
};

/* --------------------------------------------------
   📩 ENVOI DU MESSAGE – APPEL API FASTAPI
-------------------------------------------------- */
export const sendContactEmail = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        company: formData.company,
        subject: formData.subject,
        message: formData.message,
      }),
    });

    // --- Gestion d'erreur HTTP ---
    if (!response.ok) {
      // L'API renvoie une phrase lisible (limite atteinte, envoi échoué).
      const erreur = await response.json().catch(() => null);
      return {
        success: false,
        message:
          typeof erreur?.detail === "string"
            ? erreur.detail
            : "L'envoi n'a pas abouti. Réessayez dans un instant ou écrivez-nous à info@geodonnee.com.",
      };
    }

    const data = await response.json();

    return {
      success: data.success,
      message: data.message || "Votre message a été envoyé avec succès.",
    };

  } catch (error) {
    console.error("Erreur API Contact:", error);
    return {
      success: false,
      message: "L'envoi n'a pas abouti. Vérifiez votre connexion, puis réessayez.",
    };
  }
};
